"use strict";

exports.__esModule = true;
exports.getAdvancedSeoTags = void 0;

var _filterCustomTags = require("../filters/filter-custom-tags");

var _filterIdentifiedTags = require("../filters/filter-identified-tags");

var _renderer = require("../../../renderer");

var _updateByIdentifier = require("../values/update-by-identifier");

var _Identifiers = require("../../types/Identifiers");

var getAdvancedSeoTags = function getAdvancedSeoTags(advancedSeaData) {
  var url = (0, _renderer.getCanonical)(advancedSeaData);
  advancedSeaData = (0, _filterIdentifiedTags.filterIdentifiedTags)(advancedSeaData);
  advancedSeaData = (0, _filterCustomTags.filterCustomTags)(advancedSeaData);
  advancedSeaData.tags = (0, _updateByIdentifier.updateValueByIdentifier)(advancedSeaData.tags, _Identifiers.IDENTIFIERS.CANONICAL, url);
  return advancedSeaData;
};

exports.getAdvancedSeoTags = getAdvancedSeoTags;